export const isAuthError = error => {
  const status = error?.response?.status

  return status === 401 || status === 403
}

export const resolveApiErrorMessage = (error, fallbackMessage = 'İşlem sırasında bir hata oluştu.') => {
  const status = error?.response?.status
  const responseMessage = error?.response?.data?.message
  const scanMessages = {
    DOCUMENT_SCAN_PENDING: 'Belgenin güvenlik taraması sürüyor. Biraz sonra tekrar kontrol edin.',
    DOCUMENT_SCAN_THREAT_FOUND: 'Belgede güvenlik tehdidi tespit edildi. Dosya görüntülenemez veya onaylanamaz.',
    DOCUMENT_SCAN_UNAVAILABLE: 'Güvenlik taraması tamamlanamadı. Belge şu an kullanılamıyor.',
    LEGACY_INVOICE_SCAN_REQUIRED: 'Bu eski belgenin güvenlik taramasına alınması gerekiyor.',
  }
  const scanCode = Object.keys(scanMessages).find(code => typeof responseMessage === 'string' && responseMessage.includes(code))
  if (scanCode) return scanMessages[scanCode]
  if (status === 401) return 'Oturumunuz sona erdi. Yeniden giriş yapın.'
  if (status === 403) return 'Bu işlem için yetkiniz bulunmuyor.'
  if (status === 404) return 'İstenen kayıt bulunamadı. Listeyi yenileyin.'
  if (status === 409) return responseMessage || 'Kayıt başka bir işlemle değişti. Yenileyip tekrar deneyin.'
  if (status === 429) return 'Çok fazla istek gönderildi. Biraz sonra tekrar deneyin.'
  if (status >= 500 || /JDBC|Hibernate|Exception|SQL|stack trace|in-service error/i.test(responseMessage || '')) {
    return `${fallbackMessage} Sunucu isteği tamamlayamadı. Tekrar deneyin.`
  }
  if (typeof responseMessage === 'string' && responseMessage.length <= 500) return responseMessage

  return fallbackMessage
}
